import React from "react";
import "./index.css";
import { Breadcrumb, Layout, Menu, Dropdown,Avatar,message, notification, Popover } from 'antd';
import {
  HomeOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  //   UserOutlined,
  // MenuFoldOutlined,
} from "@ant-design/icons";


// import Users from "../Users/pendingUser";
import { API, graphqlOperation } from "aws-amplify";
import { getUser } from "../../graphql/queries";

const { Header, Content, Footer, Sider } = Layout;
// const { SubMenu } = Menu;

const user = JSON.parse(localStorage.getItem("profile"));
// const role = localStorage.getItem("role") ? localStorage.getItem("role") : "";

export default class PendingHome extends React.Component {
  constructor() {
    super();
    this.state = { collapsed: true };
  }

  componentDidMount() {
    // console.log(localStorage.getItem("token"));
    let pattern = /^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.[A-Za-z0-9-_.+/=]*$/g;

    if (!pattern.test(localStorage.getItem("token"))) {
      window.location.pathname = "/login";
    } else if (user.status === "Approved") {
      window.location.pathname = "/";
    } else {
      notification["success"]({
        message: "Hello",
        description: "Welcome back boss.",
      });
      this.getUser();
    }
  }

  getUser = async () => {
    //   let user
    var userGet;

    API.graphql(graphqlOperation(getUser, { id: user.id }))
      .then((res) => {
        console.log(res.data);
        userGet = res.data.getUser;
        this.setState({ status: userGet.status });
      })
      .then(() => {
        // console.log(userGet);
        userGet.status === "Pending"
          ? message.warning(
              "Please wait for the Admin to approve your account. Thank you!",
              9999999999999
            )
          : message.warning(
              "Your account has been approved, you can now relogin. Thank you!",
              9999999999999
            );
      });
  };

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  render() {
    // console.log(userGet?.status);
    const contents = (
      <div className="profileContent">
        <div style={{ color: "red" }} onClick={() => this.props.logout()}>
          Logout
        </div>
      </div>
    );
    return (
      <>
        <Layout
          style={{
            minHeight: '100vh',
          }}
        >
          <Sider collapsible collapsed={this.state.collapsed} onCollapse={(value) => this.setState({collapsed: value})}>
            <div className="logo" >
              <img
                src="https://quezoncity.gov.ph/wp-content/themes/qcproject/images/qclogo_main.png"
                alt="QCLogo"
                width="60"
                height="50"
                style={{marginTop:"12px"}}
              />
            </div>
            <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
            </Menu>
          </Sider>
          <Layout className="site-layout">
          <Header
              className="site-layout-background"
              style={{
                padding:8,
              }}
            >
              <span className="withLogo">
                  <Popover
                    content={contents}
                    placement="bottomRight"
                    trigger="hover"
                  >
                    <img
                      className="homeProfile-img"
                      alt="Profile"
                      src="https://png.pngtree.com/png-vector/20200614/ourlarge/pngtree-businessman-user-avatar-character-vector-illustration-png-image_2242909.jpg"
                    />
                  </Popover>
                </span>
            </Header>
            <Content
                className="site-layout-background"
                style={{
                  margin: "24px 16px",
                  padding: 24,
                  minHeight: 280,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
              <Breadcrumb
                style={{
                  margin: '16px 0',
                }}
              >
                <Breadcrumb.Item></Breadcrumb.Item>
                <Breadcrumb.Item></Breadcrumb.Item>
              </Breadcrumb>
              <div
                className="site-layout-background"
                style={{
                  padding: 24,
                  minHeight: 360,
                }}
              >
  
              { this.state.status === "Pending" ? (
                  <img
                    alt="waiting"
                    src="https://i.giphy.com/media/xThta6TFeC2j229JNm/giphy.webp"
                    style={{ width: 200 }}
                  />
                ) : null}
              </div>
            </Content>
            <Footer
              style={{
                textAlign: 'center',
              }}
            >
              Ant Design ©2018 Created by Ant UED
            </Footer>
          </Layout>
        </Layout>
      </>
    );
  }
}